import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { NotificationService } from "@core";
import { OfflineNotificationComponent } from "@components";

@Injectable({ providedIn: "root" })
export class OfflineService {
  private _isOffline$ = new Subject<boolean>();
  isOffline$ = this._isOffline$.asObservable();

  constructor(private _notificationService: NotificationService) {
    window.addEventListener("offline", () => {
      this._handleOffline();
    });

    window.addEventListener("online", () => {
      this._handleOnline();
    });
  }

  private _handleOffline() {
    this._notificationService.showNotification(OfflineNotificationComponent);
    this._isOffline$.next(true);
  }

  private _handleOnline() {
    this._notificationService.closeNotification();
    this._isOffline$.next(false);
  }
}
